'use client';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
} from 'react-share';
import Image from 'next/image';
import BlogSearch from './BlogSearch';
import ContactForm from './ContactForm';

const BlogAside = ({ navData, search, data, blogpage }) => {
  const [currentUrl, setCurrentUrl] = useState('');
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentPosition = window.scrollY;

      if (currentPosition > scrollTop + 3) {
        setScrolling(true);
      } else if (currentPosition < scrollTop - 3) {
        setScrolling(false);
      }
      setScrollTop(currentPosition);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollTop]);

  return (
    <aside className="flex-1 lg:flex hidden flex-col gap-[24px]">
      <BlogSearch search={search} />
      <ContactForm data={data} />
      <Accordion type="single" collapsible className="flex flex-col gap-4">
        <AccordionItem className="border-none" value={`articles`}>
          <AccordionTrigger className="md:text-xl lg:text-xl font-bold bg-[#031416] text-white rounded-full hover:no-underline px-8">
            <div className="flex items-center gap-4">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  fill="white"
                  viewBox="0 0 256 256"
                >
                  <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM184,96a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,96Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,128Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,160Z"></path>
                </svg>
              </span>
              Popular Articles
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex flex-col w-full gap-0 px-6 font-semibold lg:text-lg divide-y">
              {data?.popular_articles?.map((item, index) => {
                return (
                  <Link
                    href={`/blog/${item?.blog_id?.slug}`}
                    key={index}
                    className="group"
                  >
                    <p
                      key={index}
                      className="py-6 group-hover:underline cursor-pointer font-title-font"
                    >
                      {item?.blog_id?.name}
                    </p>
                  </Link>
                );
              })}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      <span className="w-full h-[1px] border-b"></span>
      {/* //Blog Categories */}
      {/* <Accordion type="single" collapsible className="flex flex-col gap-4 ">
        <AccordionItem className="border-none" value={`articles`}>
          <AccordionTrigger className="md:text-xl lg:text-xl font-bold bg-[#031416] text-white rounded-full hover:no-underline px-8">
            <div className="flex items-center gap-4">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  fill="white"
                  viewBox="0 0 256 256"
                >
                  <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM184,96a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,96Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,128Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,160Z"></path>
                </svg>
              </span>
              Blog Categories
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex flex-col w-full gap-0 px-6 font-semibold lg:text-lg divide-y">
              {navData?.map((item, index) => {
                return (
                  <Link href={`/blog`} key={index}>
                    <p key={index} className="py-6 cursor-pointer">
                      {item?.name}
                    </p>
                  </Link>
                );
              })}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion> */}

      {data?.socials?.length > 0 && (
        <div
          className={`p-4 flex sticky md:top-2 transition-all duration-300 flex-col gap-3`}
        >
          <h1 className="font-bold text-lg">Share</h1>
          <div className="flex flex-col gap-3">
            {data?.socials.map((social, index) => {
              return (
                <div key={index} className="group">
                  {social.type === 'facebook' && (
                    <FacebookShareButton
                      url={currentUrl}
                      className="flex items-center cursor-pointer gap-3"
                    >
                      <Image
                        src={`data:image/svg+xml,${encodeURIComponent(
                          social?.icon
                        )}`}
                        alt="icon"
                        width={28}
                        height={28}
                        className="w-[28px] h-[28px]"
                      />
                      <p className="text-sm font-semibold group-hover:underline">
                        {social.label}
                      </p>
                    </FacebookShareButton>
                  )}

                  {social.type === 'twitter' && (
                    <TwitterShareButton
                      url={currentUrl}
                      className="flex items-center cursor-pointer gap-3"
                    >
                      <Image
                        src={`data:image/svg+xml,${encodeURIComponent(
                          social?.icon
                        )}`}
                        alt="icon"
                        width={28}
                        height={28}
                        className="w-[28px] h-[28px]"
                      />
                      <p className="text-sm font-semibold group-hover:underline">
                        {social.label}
                      </p>
                    </TwitterShareButton>
                  )}

                  {social.type === 'linkedin' && (
                    <LinkedinShareButton
                      url={currentUrl}
                      className="flex items-center cursor-pointer gap-3"
                    >
                      <Image
                        src={`data:image/svg+xml,${encodeURIComponent(
                          social?.icon
                        )}`}
                        alt="icon"
                        width={28}
                        height={28}
                        className="w-[28px] h-[28px]"
                      />
                      <p className="text-sm font-semibold group-hover:underline">
                        {social.label}
                      </p>
                    </LinkedinShareButton>
                  )}

                  {social.type === 'whatsapp' && (
                    <WhatsappShareButton
                      url={currentUrl}
                      className="flex items-center cursor-pointer gap-3"
                    >
                      <Image
                        src={`data:image/svg+xml,${encodeURIComponent(
                          social?.icon
                        )}`}
                        alt="icon"
                        width={28}
                        height={28}
                        className="w-[28px] h-[28px]"
                      />
                      <p className="text-sm font-semibold group-hover:underline">
                        {social.label}
                      </p>
                    </WhatsappShareButton>
                  )}

                  {social.type === 'email' && (
                    <a
                      href={`mailto:?body=${currentUrl}`}
                      target="_top"
                      className="flex items-center cursor-pointer gap-3"
                    >
                      <Image
                        src={`data:image/svg+xml,${encodeURIComponent(
                          social?.icon
                        )}`}
                        alt="icon"
                        width={28}
                        height={28}
                        className="w-[28px] h-[28px]"
                      />
                      <p className="text-sm font-semibold group-hover:underline">
                        {social.label}
                      </p>
                    </a>
                  )}

                  {social.type === 'telegram' && (
                    <TelegramShareButton
                      url={currentUrl}
                      className="flex items-center cursor-pointer gap-3"
                    >
                      <Image
                        src={`data:image/svg+xml,${encodeURIComponent(
                          social?.icon
                        )}`}
                        alt="icon"
                        width={28}
                        height={28}
                        className="w-[28px] h-[28px]"
                      />
                      <p className="text-sm font-semibold group-hover:underline">
                        {social.label}
                      </p>
                    </TelegramShareButton>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </aside>
  );
};

export default BlogAside;
